import React from "react";

const Toria = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Toria</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className=" table table-striped table-bordered">
        <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>TL-15 [Released in 14.01.1982]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-3 kgs per acre</td>
              <td>Ist week of September</td>
              <td>3</td>
              <td>85 days</td>
              <td>Bold &amp; brown grains. Oil content 41%.</td>
              <td>4-5 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>TH-68</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-3 kgs per acre</td>
              <td>Ist week of September</td>
              <td>3</td>
              <td>89 days</td>
              <td>Bold grains, medium height plants. Oil content 43-44%.</td>
              <td>6-7 quintals per acre</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>T-9 [Released in 21.08.1975]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-3 kgs per acre</td>
              <td>Ist week of September</td>
              <td>3</td>
              <td>91 days</td>
              <td>Bold grains. Oil content 43.6%.</td>
              <td>5-6 quintals per acre</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Toria;
